import React from 'react';
import Tag, { type TagTone } from '../components/ui/Tag';
import { STATUS_LABELS, type RequisitionStatus, type Urgency } from './requisitionsApi';

const STATUS_TAG_TONE: Record<RequisitionStatus, TagTone | 'accent'> = {
  draft: 'neutral',
  pending_approval: 'warn',
  approved: 'accent',
  bought: 'info',
  arrived: 'good',
  closed: 'neutral',
  cancelled: 'neutral',
};

export const StatusChip: React.FC<{ status: RequisitionStatus; className?: string }> = ({
  status,
  className = '',
}) => (
  <Tag tone={STATUS_TAG_TONE[status]} className={className}>
    {STATUS_LABELS[status]}
  </Tag>
);

/**
 * Shown only for urgent. Normal is the resting state and says nothing; low
 * would be a chip nobody acts on.
 */
export const UrgentTag: React.FC<{ urgency: Urgency }> = ({ urgency }) =>
  urgency === 'urgent' ? (
    <Tag tone="bad">
      <span className="inline-flex items-center gap-1">
        <svg aria-hidden="true" viewBox="0 0 16 16" fill="none" className="h-3 w-3 flex-none">
          <path fill="currentColor" d="M8 1.5a1 1 0 0 1 .87.5l6 10.5A1 1 0 0 1 14 14H2a1 1 0 0 1-.87-1.5l6-10.5A1 1 0 0 1 8 1.5Zm0 4a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-3A.75.75 0 0 0 8 5.5Zm0 6.75a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z" />
        </svg>
        Urgent
      </span>
    </Tag>
  ) : null;

export default StatusChip;
